(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .directive('categoryNavigation', categoryNavigation);

    categoryNavigation.$inject = ['$log', '$state', '$rootScope', '$translate', '$localStorage', 'CategoryService', '$stateParams'];

    function categoryNavigation($log, $state, $rootScope, $translate, $localStorage, CategoryService, $stateParams) {
        var directive = {
            restrict : 'E',
            templateUrl: 'app/category/navigation/navigation.html',
            scope: {
                minimized: '='
            },
            link : linkFunc
        };

        return directive;

        function linkFunc(scope) {
            var vm = scope.vm = {};
            vm.minimized = scope.minimized;
            vm.lang = $translate.use();
            vm.selectedCategoryId = parseInt($stateParams.id, 10);

            // FUNCITONS PUBLIC
            vm.pageLoaded = pageLoaded;
            vm.book = book;
            vm.changedSelection = changedSelection;

            // OTHER
            $rootScope.$on('$translateChangeSuccess', function () {
                vm.lang = $translate.use();
            });

            loadCategoryTiles();

            return vm;

            // FUNCTION DECLARATIONS
            function loadCategoryTiles() {
                CategoryService.loadCategories().then(successCategories, error);
            }


            function successCategories(response) {
                $log.debug('CategoryController | Fetching category tiles', response.data);
                vm.categories = response.data;
            }

            function error(response) {
                $log.debug('CategoryController | ERROR:',response.data);
            }

            function pageLoaded() {
                if (vm.categories) {
                    return true;
                }
                return false;
            }

            function changedSelection() {
                book(vm.selectedCategoryId);
            }

            function book(itemId) {
                $log.debug('CategoryController | opening category with id',itemId);
                $state.go('part', {'id':itemId});
            }
        }
    }
})();
